export default [{
    path: '/liquidacao-cji3',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Liquidação da CJI3 Histórico',
        path: 'historico',
        component: () => import('@/views/liquidacaoCji3/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups'},
            { name: 'Liquidação da CJI3' }
          ]
        },
      },
      {
        name: 'Liquidação da CJI3 Adicionar',
        path: 'edit',
        component: () => import('@/views/liquidacaoCji3/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups'},
            { name: 'Liquidação da CJI3', path: '/liquidacao-cji3/historico' },
            { name: 'Adicionar' }
          ]
        },
      }
    ]
  }]


